import React from "react";
import {ISpecifications} from "../../models/utils/ISpecifications";
import {elementsNameKey} from "../../models/utils/EElementType";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Specifications to display.
     */
    specifications: ISpecifications
}

/**
 * Formats and displays the specifications of equipment.
 * @author Alizée Grand
 * @version 1.1
 * @creation 31/05/2022
 * @last_update 11/07/2022
 **/
class DisplaySpecifications extends React.Component<Props> {

    render() {

        /**
        * Retrieves from the props the function to access the translation.
        **/
        const getTranslation = this.props.t;

        return (

            <div>
                <span>{getTranslation("display.specs.type")} : </span> <b>{getTranslation(elementsNameKey[this.props.specifications.type])}</b>
                <br/>
                <span>{getTranslation("display.specs.quantity")} : </span> {this.props.specifications.quantity}
            </div>

        );

    };

}

export default withTranslation()(DisplaySpecifications);
